import { render } from "./ProductoForm.vue?vue&type=template&id=2170db56&scoped=true"
import script from "./ProductoForm.vue?vue&type=script&lang=js"
export * from "./ProductoForm.vue?vue&type=script&lang=js"

import "./ProductoForm.vue?vue&type=style&index=0&id=2170db56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2170db56"]])

export default __exports__